export class StoreError extends Error {
  code: number | undefined = undefined;

  constructor(message: string, code?: number) {
    super(message);
    this.code = code;
  }
}
